import React from 'react';
import ContactsContainer from './ContactsContainer';

export default () => <ContactsContainer />;
